import { render, staticRenderFns } from "./wcrd_fngrprntng.vue?vue&type=template&id=3f64106c&scoped=true&"
import script from "./wcrd_fngrprntng.vue?vue&type=script&lang=js&"
export * from "./wcrd_fngrprntng.vue?vue&type=script&lang=js&"
import style0 from "./wcrd_fngrprntng.vue?vue&type=style&index=0&id=3f64106c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f64106c",
  null
  
)

export default component.exports